/**
 * Whether the view asks the server for the 3D view's box (ADR 0074): always, unless the URL says
 * `box=0`, which the battle bench uses to measure the same view with and without it.
 */
export function wants3dBox(): boolean {
  return new URLSearchParams(globalThis.location.search).get('box') !== '0';
}
